export default "/images/logo.png?a5cfc2be2a8e5638e07925cf1567d5bc";